import { $t } from '@/i18n';
// 对应 page.type 字段
export const TYPE = {
    Page: 'page', // 低码页面
    Code: 'code', // 本地开发页面
    AI: 'ai', // AI页面
};
// 对应 page.pageType 字段
export const PAGE_TYPE = {
    CONTENT: 'content',
    PAGELET: 'pagelet',
    NAV: 'nav',
    SIDEBAR: 'sidebar',
    HEADER: 'header',
    FOOTER: 'footer',
    DATA_TABLE: 'datatable',
    MODAL: 'modal',
};
export const PAGE_TYPE_OPTIONS = [
    {
        value: 'content',
        label: $t('k_59b4978'),
    },
    {
        value: 'pagelet',
        label: $t('k_35b9cacb'),
    },
    {
        value: 'nav',
        label: $t('k_a3aeb4a1'),
    },
    {
        value: 'sidebar',
        label: $t('k_338ab8ee'),
    },
    {
        value: 'header',
        label: $t('k_dee04081'),
    },
    {
        value: 'footer',
        label: $t('k_aa3fe1fb'),
    },
    {
        value: 'modal',
        label: $t('k_ab346fdc'),
    },
];
export const LAYOUT_TYPE_OPTIONS = [
    {
        value: 'header-sidebar-content',
        label: $t('k_c0c196cd'),
    },
    {
        value: 'header-content',
        label: $t('k_902c005'),
    },
    {
        value: 'sidebar-content',
        label: $t('k_c27629db'),
    },
    {
        value: 'content',
        label: $t('k_389afe34'),
    },
];
export const SCROLL_MODE_OPTIONS = [
    {
        value: 'system',
        label: $t('k_95061ec5'),
    },
    {
        value: 'fix-top',
        label: $t('k_a6cf7a31'),
    },
    {
        value: 'not-fix-top',
        label: $t('k_ea62011c'),
    },
];
export const WATERMARK_OPTIONS = [
    {
        value: 'system',
        label: $t('k_95061ec5'),
    },
    {
        value: 'on',
        label: $t('k_175cf024'),
    },
    {
        value: 'off',
        label: $t('k_10c72f14'),
    },
];
